import { Icon, InlineChildren, Text } from '@doordash/design-language';
import PropTypes from 'prop-types';
import React from 'react';

var ErrorMessage = function ErrorMessage(_ref) {
  var id = _ref.id,
      error = _ref.error;
  return React.createElement(InlineChildren, {
    size: InlineChildren.Sizes.XxSmall,
    alignItems: InlineChildren.Alignment.Center,
    justifyContent: InlineChildren.Justification.FlexStart,
    id: id
  }, React.createElement(Icon, {
    type: Icon.Types.WarningCircleFill,
    size: Icon.Sizes.Small,
    color: Icon.Colors.TextError,
    title: "Error"
  }), React.createElement(Text, {
    styles: Text.Styles.Medium14,
    color: Text.Colors.TextError
  }, error));
};

ErrorMessage.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  id: PropTypes.string
};
export default ErrorMessage;